export default __webpack_public_path__ + "static/media/user-icon.db46179b.svg";